import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { PUBLIC_CLIENT_APPLICATION, configuration } from '../ServiceRequest';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
    const { isAuthenticated, isLoadingAuth } = useAuth();
    const location = useLocation();
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        const checkToken = async () => {
            const account = PUBLIC_CLIENT_APPLICATION.getActiveAccount();
            if (!account) {
                setChecked(true);
                return;
            }

            try {
                await PUBLIC_CLIENT_APPLICATION.acquireTokenSilent({
                    scopes: configuration.loginRequestScopes,
                    account,
                });
            } catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    
                    await PUBLIC_CLIENT_APPLICATION.loginRedirect({
                        scopes: configuration.loginRequestScopes,
                        redirectUri: configuration.redirectUri,
                    });

                    window.location.reload();

                } else {
                    console.error(error);
                }
            } finally {
                setChecked(true);
            }
        };

        checkToken();
    }, []);

    if (!checked || isLoadingAuth) return null;

    if (!isAuthenticated) {
        localStorage.setItem("redirect_uri", location.pathname);
        return <Navigate to="/" replace />;
    }

    return children;
};

export default PrivateRoute;
